import Box, {type BoxProps} from '@mui/material/Box';

export const ETBContainer = ({children, sx = [], ...props}: BoxProps) => {
    return (
        <Box sx={[{padding: '0 2rem'}, ...(Array.isArray(sx) ? sx : [sx])]} {...props}>
            {children}
        </Box>
    );
};
